import React, { useEffect, useState, useMemo } from "react";
import { useAxios } from "../../../common_nextgen/axios/AxiosHelper";
import useCustomNavigate from "../../../common_nextgen/common_components/Navigation/NextGenNavigation";
import getBackendUrl from "../../../environment/BackendService";
import { fetchDropdownValues } from "../../../common_nextgen/common_components/dropdown/DropdownHelper";
import { useLocation } from "react-router-dom";
import { ROUTE_PATHS } from "../../../common_nextgen/utils/Constants";
import { useToast } from "../../../common_nextgen/hooks/ToastContext";
import { downloadCSV } from "../../../common_nextgen/utils/UtilFunctions";
import {
  useLocationState,
  useReceiveExternalMessages,
} from "../../../common_nextgen/common_components/common-hooks/useLocationState";

const useOutOfPocketMaxScheduleSteps = () => {
  const [data, setData] = useState([]);
  const [first, setFirst] = useState(0);
  const [screenInfo, setScreenInfo] = useState({});
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowData, setRowData] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigateToPage = useCustomNavigate();
  const [dropdownValues, setDropdownValues] = useState({});
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("no");
  const toast = useToast();
  const location = useLocation();
  const { axios_helper_no_header } = useAxios();

  const {
    OUT_OF_POCKET_MAX_SCHEDULE_STEPS_DETAILS_EXT,
    OUT_OF_POCKET_MAX_SCHEDULE,
    ADD_OUT_OF_POCKET_MAX_SCHEDULE_DETAIL,
    EDIT_OUT_OF_POCKET_MAX_SCHEDULE_DETAIL,
    DISPLAY_OUT_OF_POCKET_MAX_SCHEDULE_DETAIL,
    OUT_OF_POCKET_PATIENT_PAY_SCHEDULE,
    OUT_OF_POCKET_MAX_SCHEDULE_SUB_STEPS,
  } = ROUTE_PATHS;

  /*const { state: stateVal } = location;
  const [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);
  console.log("current state in form", currentState, previousState);*/
  const { currentState, previousState, setStateVal } = useLocationState({
    initialState: location.state || [],
  });
  const {
    selectedSchedules = [],
    previousScreen = OUT_OF_POCKET_MAX_SCHEDULE,
    currentIndex: initialIndex = 0,
    externalMode: initialExternalMode = false,
    initialParamsData = {
      opcScheduleName: selectedSchedules[initialIndex]?.opcScheduleName,
      description: "",
      basis: "",
      steps: "",
    },
  } = currentState;

  /*const {
    selectedPriceSchedules = [],
    previousScreen = OUT_OF_POCKET_MAX_SCHEDULE,
    currentIndex: initialIndex = 0,
  } = location.state || {};*/
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [externalMode, setExternalMode] = useState(initialExternalMode);
  useReceiveExternalMessages(setStateVal, setExternalMode);

  const screen_title = "Out Of Pocket Max Schedule Steps";
  const screenNumber = "RCOPD001";
  /*const [fetchDataParam, setFetchDataParam] = useState({
    opcScheduleName: selectedSchedules[currentIndex].opcScheduleName,
  });*/

  const fetchDataParam = useMemo(
    () => ({
      opcScheduleName: selectedSchedules[currentIndex]?.opcScheduleName,
    }),
    [currentIndex, selectedSchedules]
  );

  const [paramsData, setParamsData] = useState(initialParamsData);

  const formFields = [
    {
      fieldLabel: "Schedule",
      name: "opcScheduleName",
      label: "Schedule",
      type: "text",
      value: "",
      maxLength: 10,
      fieldNature: "readOnly",
    },
    {
      fieldLabel: "Description",
      name: "description",
      label: "Description",
      type: "text",
      value: "",
      maxLength: 40,
      fieldNature: "readOnly",
    },
    {
      fieldLabel: "OPC Basis*Valid Values",
      name: "basis",
      label: "Basis",
      type: "dropdown",
      value: "",
      maxLength: 25,
      fieldNature: "readOnly",
    },
    {
      fieldLabel: "Steps",
      name: "steps",
      label: "Steps",
      type: "text",
      value: "",
      maxLength: 2,
      fieldNature: "readOnly",
    },
  ];

  const dropdownOptions = [
    { field_label: "OPC Basis", condition: "*Valid Values" },
  ];

  const dropdownCondition = {
    dropDowns: dropdownOptions.map((item) => item.field_label + item.condition),
  };

  const ctaButtons = [
    {
      button_label: "Add Out Of Pocket Max Schedule Steps",
      button_handeler: () => {
        addStepValidation();
      },
      button_key: "F6",
    },

    {
      button_label: "Export as CSV",
      button_handeler: () => {
        exportAsCSV();
      },
      button_key: "",
    },
  ];

  const addStepValidation = () => {
    const params = {
      opcScheduleName: paramsData.opcScheduleName,

      action: "add-new-step",
    };
    axios_helper_no_header(
      "GET",
      "api/opdOutPoktMaxSchDtl/validateStep",
      null,
      params
    )
      .then((response) => {
        navigateToPage(ADD_OUT_OF_POCKET_MAX_SCHEDULE_DETAIL, [
          ...previousState,
          { ...currentState, currentIndex, externalMode },
          {
            previousScreen: location.pathname,
            scheduleName: paramsData.opcScheduleName,
          },
        ]);
      })
      .catch((error) => {
        console.error("There was validation failed!", error);
        const { responseStatus: { displayErrorFields = null, message } = {} } =
          error.data;
        toast.current.show({
          severity: "error",
          summary: "",
          detail: message,
          life: 3000,
        });
      });
  };

  const menuOptions = [
    {
      label: "Edit",
      icon: <span className="material-icons">edit</span>,
      command: () => {
        navigateToPage(EDIT_OUT_OF_POCKET_MAX_SCHEDULE_DETAIL, [
          ...previousState,
          { ...currentState, currentIndex, externalMode },
          {
            selectedSteps: selectedRows.length ? selectedRows : [rowData],
            previousScreen: location.pathname,
            scheduleName: paramsData.opcScheduleName,
            currentIndex: 0,
            paramsData: paramsData,
          },
        ]);
      },
    },
    {
      label: "Delete",
      icon: <span className="material-icons">delete</span>,
      command: () => {
        openConfirmationModal();
      },
    },
    {
      label: "Display",
      icon: <span className="material-icons">visibility</span>,
      command: () => {
        navigateToPage(DISPLAY_OUT_OF_POCKET_MAX_SCHEDULE_DETAIL, [
          ...previousState,
          { ...currentState, currentIndex, externalMode },
          {
            selectedSteps: selectedRows.length ? selectedRows : [rowData],
            previousScreen: location.pathname,
            scheduleName: paramsData.opcScheduleName,
            currentIndex: 0,
            paramsData: paramsData,
          },
        ]);
      },
    },
    {
      label: "Detail Extension",
      icon: <span className="material-icons">extension</span>,
      command: () => {
        detailExtensionValidation();
      },
    },
    {
      label: "Substep",
      icon: <span className="material-icons">subdirectory_arrow_right</span>,
      command: () => {
        subStepValidation();
      },
    },
    {
      label: "Patient Pay",
      icon: <span className="material-icons">payment</span>,
      command: () => {
        patientPayValidation();
      },
    },
  ];

  const subStepValidation = () => {
    const params = {
      opcScheduleName: paramsData.opcScheduleName,
      opdStepNumber: rowData.opdStepNumber,
      action: "sub-step",
    };
    axios_helper_no_header(
      "GET",
      "api/opdOutPoktMaxSchDtl/validateStep",
      null,
      params
    )
      .then((response) => {
        navigateToPage(OUT_OF_POCKET_MAX_SCHEDULE_SUB_STEPS, [
          ...previousState,
          { ...currentState, currentIndex, externalMode },
          {
            selectedSteps: selectedRows.length ? selectedRows : [rowData],
            description: paramsData.description,
            steps: paramsData.steps,
            scheduleName: paramsData.opcScheduleName,
            basis: paramsData.basis,
            previousScreen: location.pathname,
            currentIndex: 0,
          },
        ]);
      })
      .catch((error) => {
        console.error("There was validation failed!!", error);
        const { responseStatus: { displayErrorFields = null, message } = {} } =
          error.data;
        toast.current.show({
          severity: "error",
          summary: "",
          detail: message,
          life: 3000,
        });
      });
  };

  const patientPayValidation = () => {
    const params = {
      opcScheduleName: paramsData.opcScheduleName,
      opdStepNumber: rowData.opdStepNumber,
      action: "patient-pay",
    };
    axios_helper_no_header(
      "GET",
      "api/opdOutPoktMaxSchDtl/validateStep",
      null,
      params
    )
      .then((response) => {
        navigateToPage(OUT_OF_POCKET_PATIENT_PAY_SCHEDULE, [
          ...previousState,
          { ...currentState, currentIndex, externalMode },
          {
            selectedSteps: selectedRows.length ? selectedRows : [rowData],
            description: paramsData.description,
            steps: paramsData.steps,
            scheduleName: paramsData.opcScheduleName,
            basis: paramsData.basis,
            previousScreen: location.pathname,
            currentIndex: 0,
          },
        ]);
      })
      .catch((error) => {
        console.error("There was validation failed!!", error);
        const { responseStatus: { displayErrorFields = null, message } = {} } =
          error.data;
        toast.current.show({
          severity: "error",
          summary: "",
          detail: message,
          life: 3000,
        });
      });
  };

  const detailExtensionValidation = () => {
    const params = {
      opcScheduleName: paramsData.opcScheduleName,
      opdStepNumber: rowData.opdStepNumber,
      action: "detail-extension",
    };
    axios_helper_no_header(
      "GET",
      "api/opdOutPoktMaxSchDtl/validateStep",
      null,
      params
    )
      .then((response) => {
        navigateToPage(OUT_OF_POCKET_MAX_SCHEDULE_STEPS_DETAILS_EXT, [
          ...previousState,
          { ...currentState, currentIndex, externalMode },
          {
            selectedSteps: selectedRows.length ? selectedRows : [rowData],
            description: paramsData.description,
            steps: paramsData.steps,
            scheduleName: paramsData.opcScheduleName,
            previousScreen: location.pathname,
          },
        ]);
      })
      .catch((error) => {
        console.error("There was validation failed!", error);
        const { responseStatus: { displayErrorFields = null, message } = {} } =
          error.data;
        toast.current.show({
          severity: "error",
          summary: "",
          detail: message,
          life: 3000,
        });
      });
  };

  const columnDef = [
    { header: "Step", field: "opdStepNumber" },
    { header: "Accum Component Code", field: "opdAccumComponentCode" },
    {
      header: "Out Of Pocket Max Individual Amount",
      field: "opdMbrOopMaxAmount",
    },
    { header: "Out Of Pocket Max Family Amount", field: "opdFamOopMaxAmount" },
    { header: "Copay Patient Pay Table", field: "opdPricingTableFlag" },
    { header: "Brand Copay Amount", field: "opdBrandCopayAmount" },
    { header: "Generic Copay Amount", field: "opdGenericCopayAmount" },
    { header: "Brand Percent Amount", field: "opdBrandPercentAmt" },
    { header: "Generic Percent Amount", field: "opdGenericPercentAmt" },
    { header: "Percent Basis", field: "opdPercentBasis" },
    { header: "Update Copay", field: "opdCopayDeductibleFlag" },
  ];

  const parmKey = "opdStepNumber";

  const fetchData = async () => {
    console.log("fetch data");
    const page = first / rows;
    try {
      const raw_response = await axios_helper_no_header(
        "GET",
        `api/opdOutPoktMaxSchDtl`,
        null,
        {
          page: page,
          size: rows,
          ...fetchDataParam,
        }
      );
      const response = raw_response.responseData;
      const pageResponse = raw_response.responsePaginationDTO;
      if (response.length === 0) {
        setData([]);
        setTotalRecords(0);
        console.log("response.length is ", response.length);
        toast.current.show({
          severity: "info",
          summary: "",
          detail: response.responseStatus.message,
          life: 3000,
        });
      } else {
        setData(response);
        console.log("response", response);
        console.log(pageResponse.totalRecords);
        setTotalRecords(pageResponse.totalRecords);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRecords(0);
    }
  };

  const fetchSubScreenInfo = (paramsData) => {
    const hasValidParams =
      paramsData &&
      Object.keys(paramsData).length &&
      paramsData.opcScheduleName;
    if (hasValidParams) {
      axios_helper_no_header(
        "GET",
        "api/opcOutPoktMaxSchCtrl/" +
          encodeURIComponent(selectedSchedules[currentIndex]?.opcScheduleName),
        null
      )
        .then((response) => {
          fetchDisplayParamsData(response.responseData);
        })
        .catch((error) => {
          const errorMessage =
            error.data?.responseStatus?.message || error.message;
          console.error("There was an error fetching the data!", error);
          toast.current.show({
            severity: "error",
            summary: "",
            detail: errorMessage,
            life: 3000,
          });
          closeConfirmationModal();
        });
    }
  };

  const fetchDisplayParamsData = (response) => {
    setParamsData({
      ...paramsData,
      opcScheduleName: response.opcScheduleName,
      description: response.opcDescription,
      basis: response.opcBasis,
      steps: response.opcStepCount,
    });
  };

  const fetchDropdownData = async (dataDropdown) => {
    try {
      const response = await fetchDropdownValues(dataDropdown);
      setDropdownValues(response);
    } catch (error) {
      console.error("Error fetching dropdown values:", error);
    }
  };

  useEffect(() => {
    fetchDropdownData(dropdownCondition);
  }, []);

  useEffect(() => {
    const hasValidParams =
      paramsData &&
      Object.keys(paramsData).length &&
      paramsData.opcScheduleName;
    if (hasValidParams) fetchData();
  }, [paramsData, rows, currentPage, currentIndex]);

  useEffect(() => {
    fetchSubScreenInfo(initialParamsData);
  }, [currentIndex]);

  const onPageChange = (event) => {
    console.log("page change", event.first, event);
    setFirst(event.first);
    setCurrentPage(event.page);
    setRows(event.rows);
  };

  const openConfirmationModal = () => {
    setIsConfirmationModalOpen(true);
  };

  const closeConfirmationModal = () => {
    console.log(selectedOption);
    setIsConfirmationModalOpen(false);
    setSelectedOption("no");
  };

  const deletePriceSchedule = () => {
    if (selectedOption === "yes") {
      const params = {
        opcScheduleName: paramsData.opcScheduleName,
        opdStepNumber: rowData.opdStepNumber,
      };
      axios_helper_no_header("DELETE", "api/opdOutPoktMaxSchDtl", null, params)
        .then((response) => {
          const updatedItems = data.filter((item) => item[parmKey] !== rowData);
          setTotalRecords((prevTotal) => prevTotal - 1);
          setData(updatedItems);
          toast.current.show({
            severity: "success",
            summary: "",
            detail: response.responseStatus.message,
            life: 3000,
          });
          closeConfirmationModal();
          if (currentPage > 0) {
            setFirst(0);
            setCurrentPage(0);
          } else {
            fetchData();
          }
          fetchSubScreenInfo(initialParamsData);
        })
        .catch((error) => {
          console.error("There was an error deleting the data!", error);
          const errorMessage =
            error.data?.responseStatus?.message || error.message;
          toast.current.show({
            severity: "error",
            summary: "",
            detail: errorMessage,
            life: 3000,
          });
          closeConfirmationModal();
        });
    } else {
      closeConfirmationModal();
    }
  };

  const exportAsCSV = async () => {
    const queryParams = { ...paramsData };
    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/opdOutPoktMaxSchDtl/exportcsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };

  const updateParamData = (data) => {
    setFirst(0);
    setCurrentPage(0);
    setParamsData(data);
  };

  const leftButtons = [
    {
      button_label: "Back",
      button_handeler: () => {
        if (externalMode) {
          const message = {
            message: "navigate-to-external-program",
            url: previousScreen,
            parameters: {
              state: [...previousState],
            },
          };
          console.log("back messages", message);
          window.parent.postMessage(message, "*");
        } else if (currentIndex < selectedSchedules.length - 1) {
          setCurrentIndex((prevIndex) => prevIndex + 1);
        } else {
          navigateToPage(previousScreen, previousState);
        }
      },
      button_key: "F12",
    },
  ];

  useEffect(() => {
    if (!paramsData.opcScheduleName) {
      setParamsData(initialParamsData);
      fetchSubScreenInfo(initialParamsData);
    }
  }, [initialParamsData]);

  return {
    screenNumber,
    screen_title,
    formFields,
    dropdownValues,
    paramsData,
    updateParamData,
    ctaButtons,
    data,
    parmKey,
    menuOptions,
    columnDef,
    setRowData,
    selectedRows,
    setSelectedRows,
    first,
    rows,
    totalRecords,
    currentPage,
    onPageChange,
    isConfirmationModalOpen,
    closeConfirmationModal,
    deletePriceSchedule,
    setSelectedOption,
    leftButtons,
  };
};

export default useOutOfPocketMaxScheduleSteps;
